
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {mergeMap, map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';;
 

import { LoggerService } from '../../../shared/service/logger/logger.service';
import { AuthService } from '../../../shared/service/auth/auth.service';
import { AgentService } from 'app/agent/agent-service/agent.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoginService {

  constructor(private logger: LoggerService, public http: HttpClient,
    private authServise: AuthService,
    private agentService: AgentService

  ) { }

  

  login(data) {
    return firstValueFrom(this.http.post("/auth/agent", data).pipe(
          map(res => res)))
      .catch((err)=>{ 
        console.error("login error: ", err);
        
        const error = {
          message: err.error.message,
          status: err.status
        }
        return Promise.reject(error) 
      });
  }
  forgetPassword(data) {
    return this.http.post("/api/agents/forgetpassword", data).pipe(
      map(res => res),
      catchError((err)=>{ 
        return Promise.reject(err) 
      }),);
  }

  getAgencyData(url){
    return firstValueFrom(this.http.post("/api/amsDatas/getAgencyData", {url}).pipe(
          map(res => res)))
      .catch(this.handleError);
  }
  logoutAgentMailClient(){
    return new Promise((resolve, reject)=>{
      this.agentService.getAgentDetails().pipe(
      mergeMap(res=>{
        let data: any = {};
        if (res) {
          data._id = res._id;
          data.firstname = res.firstname;
          data.mailClient = null
          data.outlook_access_token = null
          data.outlook_refresh_token = null
          return this.agentService.updateAgentProfile(data)
        }
      }))
      .subscribe(res=>{
        resolve(true)
      })
    })
  }


  private handleError(error: any) {
    console.error(error);
    let err = JSON.parse(error._body);
    return observableThrowError(JSON.parse(error._body));
  }
}
